module.exports = __webpack_public_path__ + "static/media/jteventshead.29a8d24a.jpg";